<template>
  <router-link
    v-if="podcast.uuid"
    :to="`/listen/${podcast.publisher.slug}/${podcast.slug}/${podcast.uuid}`"
    class="exclusive-podcast"
  >
    <img :src="podcast.display_image_url" >
    <div class="gradient-overlay" />
    <p class="exclusive-podcast__title">
      {{ podcast.title }}
    </p>
  </router-link>
</template>

<script>
// TODO: Replace to: with below URL when API returns publisher
// :to="`/listen/${podcast.publisher.slug}/${podcast.slug}/${podcast.uuid}`"
export default {
  props: {
    podcast: {
      type: Object,
      default: () => {},
    },
  },
};
</script>

<style lang="scss" scoped>
  .exclusive-podcast {
    height: 250px;
    position: relative;

    display: block;

    &__title {
      font-size: 16px;
      color: white;

      width: 100%;

      position: absolute;
      bottom: 12px;
      left: 16px;
    }

    img {
      position: absolute;

      width: 100%;
      height: 100%;
      object-fit: cover;

      top: 0;
      left: 0;
    }

    .gradient-overlay {
      height: 50%;
      width: 100%;

      position: absolute;

      bottom: 0;
      left: 0;

      background: linear-gradient(180deg, rgba(0,0,0,0) 0%, rgba(0, 0, 0, 0.5) 100%);
    }

    @media (max-width: 1024px) {
      height: 268px;
    }

    @media (max-width: 768px) {
      height: 200px;
    }

    @media (max-width: 768px) {
      height: 200px;
    }

    @media (max-width: 567px) {
      height: 181px;
    }
  }
</style>



// WEBPACK FOOTER //
// app/src/components/ExclusiveCard.vue